import React from 'react';
export function WebhookIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.215c0-.746-.204-1.444-.56-2.041-.282-.475-.295-1.104.095-1.495.39-.39 1.206-.248 1.491.285.7.981.974 1.953.974 3.25a6 6 0 01-11.917 1h-2.35a2 2 0 110-2H12a1 1 0 011 1 4 4 0 008 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.025 19.65a3.981 3.981 0 002.048.536c.505-.006 1.074.11 1.218.663.028.109.05.22.05.333.004.48-.511.944-1.13.944-1.2.115-2.062-.095-3.186-.744a6 6 0 015.093-10.82l1.175-2.036a1.999 1.999 0 012.732-2.733 2 2 0 01-1 3.733l-1.634 2.83a1 1 0 01-1.366.366 4 4 0 10-4 6.928z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.974 4.137a3.981 3.981 0 00-1.488 1.505c-.44.665-.994.975-1.49.73-.539-.22-.71-.761-.48-1.264a6 6 0 119.283 7.117l1.175 2.036a2 2 0 011 3.732 2 2 0 01-2.732-2.732l-1.634-2.83a1 1 0 01.366-1.366 4 4 0 10-4-6.928z"
  }));
}